import { render, staticRenderFns } from "./addEvent.vue?vue&type=template&id=1b0bfa2a&scoped=true&"
import script from "./addEvent.vue?vue&type=script&lang=js&"
export * from "./addEvent.vue?vue&type=script&lang=js&"
import style0 from "./addEvent.vue?vue&type=style&index=0&id=1b0bfa2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0bfa2a",
  null
  
)

export default component.exports